import React from 'react';
import './Loader.scss';

class Loader extends React.Component {
  render() {
    return (
      <div className="c-loader">
        <div className="c-loader--bouncing">
          <div className="c-loader--bouncing-ball" />
          <div className="c-loader--bouncing-ball" />
          <div className="c-loader--bouncing-ball" />
        </div>
      </div>
    );
  }
}

export default Loader;
